export default () => ({
    open: false,
    openSidebar: false,
    menuCloseDelay: 200,
    menuCloseTimeout: null,
    menuLeave() {
        let that = this;
        this.menuCloseTimeout = setTimeout(() => {
            that.menuClose();
        }, this.menuCloseDelay);
    },
    menuClearCloseTimeout() {
        clearTimeout(this.menuCloseTimeout);
    },
    menuClose() {
        this.open = false;
    },
    hoverTrigger: {
        ['x-ref']: 'trigger',
        ['x-on:mouseover']() {
            this.open = true;
        },
        ['x-on:mouseleave']() {
            this.menuLeave();
        },
        ['x-bind:aria-expanded']() {
            return this.open;
        },
    },
    clickTrigger: {
        ['x-ref']: 'trigger',
        ['x-bind:aria-expanded']() {
            return this.open;
        },
        ['x-on:click']() {
            return (this.openSidebar = true);
        },
        ['x-on:click.outside']() {
            return (this.openSidebar = false);
        },
    },
    dialogue: {
        ['x-show']() {
            return this.open;
        },
        ['x-on:mouseover']() {
            return this.menuClearCloseTimeout();
        },
        ['x-on:mouseleave']() {
            return this.menuLeave();
        },
        ['x-on:click']() {
            return (this.open = false);
        },
    },
});
